import {
  faBox,
  faHashtag,
  faBarcode,
  faCalendarDay,
  faBuilding,
  faIndustry,
  faMapMarkerAlt,
  faMapPin,
  faClipboardCheck,
  faClipboardList,
  faRulerHorizontal,
  faRulerCombined,
  faArrowsAltV,
  faWeight,
  faFileInvoice,
  faUser,
  faComment,
} from '@fortawesome/free-solid-svg-icons'
import createField from '../../utils/factory/createField'

export const equipmentFields = [
  {
    section: 'Detalhes do Equipamento',
    fields: [
      createField({
        id: 'organization.alias',
        label: 'Organização Atual',
        type: 'select',
        disabled: true,
        icon: faBuilding,
      }),
      createField({
        id: 'status.name',
        label: 'Status',
        type: 'select',
        disabled: true,
        placeholder: 'Selecione o status',
        icon: faClipboardList,
      }),
      createField({
        id: 'creation_transaction.purchase_date',
        label: 'Data Compra',
        type: 'date',
        placeholder: 'Adicione a data de compra',
        disabled: true,
        icon: faCalendarDay,
      }),
      createField({
        id: 'creation_transaction_item.warranty_date',
        label: 'Data Garantia',
        type: 'date',
        disabled: true,
        placeholder: 'Adicione a data de garantia',
        icon: faCalendarDay,
      }),
      createField({
        id: 'creation_transaction_item.address.formatted_address',
        label: 'Endereço',
        type: 'select',
        disabled: true,
        placeholder: 'Digite o endereço',
        icon: faMapMarkerAlt,
      }),
      createField({
        id: 'creation_transaction_item.location.formatted_location',
        label: 'Localização',
        type: 'select',
        disabled: true,
        placeholder: 'Digite a localização',
        icon: faMapPin,
        fullWidth: true,
      }),
    ],
  },
  {
    section: 'Classificação do Produto',
    fields: [
      createField({
        id: 'condition.name',
        label: 'Condição',
        type: 'select',
        disabled: true,
        placeholder: 'Digite a condição',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'category.name',
        label: 'Categoria',
        type: 'select',
        disabled: true,
        placeholder: 'Digite a categoria',
        icon: faClipboardList,
      }),
    ],
  },
]

export const editEquipmentFields = [
  {
    section: 'Dados do Equipamento',
    fields: [
      createField({
        id: 'equipment.name',
        label: 'Descrição',
        type: 'text',
        placeholder: 'Digite o equipamento',
        icon: faBox,
        disabled: true,
      }),
      createField({
        id: 'equipment.current_organization',
        label: 'Organização',
        type: 'text',
        disabled: true,
        icon: faBuilding,
      }),
      createField({
        id: 'equipment.number',
        label: 'Tombo',
        type: 'number',
        placeholder: 'Digite o número do tombo',
        disabled: true,
        icon: faHashtag,
      }),
      createField({
        id: 'equipment.serial_number',
        label: 'Número de Série',
        type: 'text',
        placeholder: 'Digite o número de série',
        icon: faBarcode,
        maxLength: 30,
      }),
      createField({
        id: 'equipment.purchase_date',
        label: 'Data Compra',
        type: 'date',
        placeholder: 'Adicione a data de compra',
        disabled: true,
        icon: faCalendarDay,
      }),
      createField({
        id: 'equipment.warranty_date',
        label: 'Data Garantia',
        type: 'date',
        disabled: true,
        placeholder: 'Adicione a data de garantia',
        icon: faCalendarDay,
      }),
    ],
  },
  {
    section: 'Classificação do Produto',
    fields: [
      createField({
        id: 'equipment.condition',
        label: 'Condição',
        type: 'text',
        disabled: true,
        placeholder: 'Digite a condição',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'equipment.category',
        label: 'Categoria',
        type: 'text',
        disabled: true,
        placeholder: 'Digite a categoria',
        icon: faClipboardList,
      }),
    ],
  },
]

export const detailsEquipmentFields = [
  {
    section: 'Dados do Equipamento',
    fields: [
      createField({
        id: 'equipment.name',
        label: 'Descrição',
        type: 'text',
        placeholder: 'Digite o descrição do equipamento',
        icon: faBox,
        disabled: true,
        fullWidth: true,
      }),
      createField({
        id: 'equipment.number',
        label: 'Número',
        type: 'text',
        placeholder: 'Digite o número do equipamento',
        icon: faHashtag,
        disabled: true,
      }),
      createField({
        id: 'equipment.status',
        label: 'Status',
        type: 'text',
        placeholder: 'Digite o status',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'equipment.current_customer',
        label: 'Cliente',
        type: 'text',
        placeholder: '-',
        icon: faUser,
        disabled: true,
        fullWidth: true,
      }),
      createField({
        id: 'equipment.destination_address',
        label: 'Endereço de Destino',
        type: 'text',
        placeholder: '-',
        icon: faMapMarkerAlt,
        disabled: true,
        fullWidth: true,
      }),
      createField({
        id: 'equipment.serial_number',
        label: 'Número de Série',
        type: 'text',
        placeholder: 'Digite o número de série',
        icon: faBarcode,
        disabled: true,
      }),
      createField({
        id: 'equipment.serial_required',
        label: 'NS Obrigatório?',
        type: 'text',
        placeholder: '-',
        icon: faBarcode,
        disabled: true,
      }),
      createField({
        id: 'equipment.completed_by',
        label: 'Criado Por',
        type: 'text',
        placeholder: 'Adicione quem criou',
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'equipment.created_at',
        label: 'Criado Em',
        type: 'text',
        placeholder: 'Adicione data de compra',
        icon: faCalendarDay,
        disabled: true,
      }),
      createField({
        id: 'equipment.purchase_date',
        label: 'Data de Compra',
        type: 'text',
        placeholder: 'Adicione data de compra',
        icon: faCalendarDay,
        disabled: true,
      }),
      createField({
        id: 'equipment.warranty_date',
        label: 'Data de Garantia',
        type: 'text',
        placeholder: 'Adicione data de garantia',
        icon: faCalendarDay,
        disabled: true,
      }),
    ],
  },
  {
    section: 'Organização e Fornecedor',
    fields: [
      createField({
        id: 'equipment.current_organization',
        label: 'Organização Atual',
        type: 'text',
        placeholder: 'Digite a organização atual',
        icon: faBuilding,
        disabled: true,
      }),
      createField({
        id: 'equipment.owner_organization',
        label: 'Empresa de Aquisição',
        type: 'text',
        placeholder: 'Digite a empresa de aquisição',
        icon: faIndustry,
        disabled: true,
      }),
      createField({
        id: 'equipment.doc_number',
        label: 'N° da Nota Fiscal',
        type: 'text',
        placeholder: 'Digite o N° da Nota Fiscal',
        icon: faFileInvoice,
        disabled: true,
      }),
      createField({
        id: 'equipment.supplier',
        label: 'Fornecedor',
        type: 'text',
        placeholder: 'Digite o fornecedor',
        icon: faIndustry,
        disabled: true,
      }),
    ],
  },
  {
    section: 'Classificação do Produto',
    fields: [
      createField({
        id: 'equipment.condition',
        label: 'Condição',
        type: 'text',
        placeholder: 'Digite a condição',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'equipment.category',
        label: 'Categoria',
        type: 'text',
        placeholder: 'Digite a categoria',
        icon: faClipboardList,
        disabled: true,
      }),
    ],
  },
  {
    section: 'Dimensões e Peso',
    fields: [
      createField({
        id: 'equipment.length',
        label: 'Comprimento (cm)',
        type: 'number',
        placeholder: 'Digite o comprimento',
        icon: faRulerHorizontal,
        disabled: true,
        isNumericFormat: true,
      }),
      createField({
        id: 'equipment.width',
        label: 'Largura (cm)',
        type: 'number',
        isNumericFormat: true,
        placeholder: 'Digite a largura',
        icon: faRulerCombined,
        disabled: true,
      }),
      createField({
        id: 'equipment.height',
        label: 'Altura (cm)',
        type: 'number',
        isNumericFormat: true,
        placeholder: 'Digite a altura',
        icon: faArrowsAltV,
        disabled: true,
      }),
      createField({
        id: 'equipment.weight',
        label: 'Peso (kg)',
        type: 'number',
        placeholder: 'Digite o peso',
        icon: faWeight,
        disabled: true,
        isNumericFormat: true,
      }),
    ],
  },
]

export const scannerEquipmentFields = [
  {
    section: 'Escaner equipamento',
    fields: [
      createField({
        id: 'equipment.number',
        label: 'Tombo',
        type: 'text',
        placeholder: 'Digite o número do tombo',
        icon: faBox,
        fullWidth: true,
      }),
    ],
  },
  {
    section: 'Confirmar Todas Devoluções',
    fields: [
      createField({
        id: 'return_confirmations.driver_id',
        label: 'Motorista',
        type: 'select',
        placeholder: 'Selecione o motorista',
        icon: faUser,
        fullWidth: true,
      }),
      createField({
        id: 'return_confirmations.details',
        label: 'Observação',
        type: 'textarea',
        placeholder: 'Adicione uma observação',
        icon: faComment,
        fullWidth: true,
      }),
    ],
  },
]
